import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FileAcrobatIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 3V7C13 8.105 13.895 9 15 9H19M11 10.5C12 12 12 13.2 12 14M12 14C12 14.8 10 16.333 9 17M12 14C12.5 14.5 13.9 15.6 15.5 16M19 8.414V19C19 20.105 18.105 21 17 21H7C5.895 21 5 20.105 5 19V5C5 3.895 5.895 3 7 3H13.586C13.851 3 14.105 3.105 14.293 3.293L18.707 7.707C18.895 7.895 19 8.149 19 8.414Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FileAcrobatIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FileAcrobatIcon);
